import { Injectable } from '@angular/core';

//custom from core
import {  ErrorHandler,  NgZone } from '@angular/core'; //added from ng
import { HttpErrorResponse } from '@angular/common/http';
import { StorageService } from './storage.service';
/** SENTRY */
import * as Sentry from "@sentry/capacitor";
//import * as Sentry  from "@sentry/angular-ivy";

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandler {

  /**
   * @ignore
    * @param zone 
   */
  constructor(
    //private errorDialogService: ErrorDialogService,
    private storage: StorageService,
    private zone: NgZone
  ) { }


  /**
   * handleError
   * @param error
   * handles errors globally
   * passes off to sentry
   * and allows user to continue 
   */
  handleError(error: Error) {
    let self = this;

    try {

      Promise.all([ 
        //this.storage.set('user', user);
        //set local storage for user
        
        self.storage.get('user'),
        self.storage.get('userId'),
  
  
      ]).then( async ( data ) => {

        if( data[1] ){
    
          Sentry.setTag("aba_user_email", data[0].email );
          Sentry.setTag("aba_user_userId", data[1] );
        }
        Sentry.captureException( error );
        

        //aba_email, user_id, ionic build version, main app
        //Sentry.captureException( error );
        //console log the error
        console.error('Error from global error handler sent to Sentry', error);
      });
      
    } catch (e) {
      //console log the error
      console.error('Error from global error handler', e);
    }


    
    
  }
}
